import styled from 'styled-components';

export default styled.div`
  div.drm-first-step {
    > span {
      display: block;
      color: rgba(23, 29, 66, 1);
      font-size: 24px;
      letter-spacing: 0;
      line-height: 32px;
      margin-right: 24px;
      margin-bottom: 47px;
    }

    &__date {
      margin-bottom: 24px;
      display: flex;
      justify-content: space-between;

      span {
        color: rgba(24, 30, 52, 0.5);
        width: 130px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 20px;
      }

      > div.date_wrapper {
        width: 245px;

        div.react-datepicker {
          &__input-container {
            > input {
              width: 100%;
              color: rgba(51, 61, 108, 1);
              font-size: 14px;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 40px;
              border: none;
              border-bottom: 1px rgba(51, 61, 108, 1) solid;
            }
          }

          &__navigation {
            top: 15px;
          }

          &__current-month {
            font-size: 14px;
            padding-bottom: 10px;
            padding-top: 5px;
          }

          &__header {
            background: none;
            border-bottom: none;
          }

          &__tab-loop {
            width: 0;
          }

          &__day {
            color: rgba(24, 30, 52, 1);
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 20px;
            text-align: center;
            width: 30px;
            height: 30px;
            padding-top: 5px;

            :hover {
              border-radius: 0;
            }

            &--selected {
              background-color: rgba(51, 61, 108, 0.1);
              border-radius: 0;
            }
          }

          &__day-names {
            border-top: 1px #d7d9e2 solid;
            border-bottom: 1px #d7d9e2 solid;
          }
        }
      }
    }

    &__data {
      width: 100%;
      max-width: 571px;
      padding: 24px 0 24px 0;
      margin-bottom: 48px;

      > div {
        height: 300px;
        padding-top: 110px;

        img {
          display: block;
          margin: 0 auto;
        }
      }

      textarea {
        padding: 16px;
        width: 100%;
        height: 300px;
        border: none;
        background-color: rgba(247, 247, 249, 1);
        border-radius: 8px;
        resize: none;
      }
    }

    button.drm-next-step-btn {
      width: 100%;
    }
  }

  div.drm-second-step {
    display: flex;

    &__left {
      width: 100%;
      max-width: 28px;
      margin-right: 16px;

      img {
        display: block;
        width: 100%;
        margin-top: 3px;
      }
    }

    &__right {
      span {
        display: block;
        color: rgba(106, 229, 159, 1);
        font-size: 24px;
        letter-spacing: 0;
        line-height: 32px;

        &:not(:first-child) {
          color: rgba(20, 27, 56, 0.4);
          margin-top: 8px;
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
        }
      }
    }
  }
`;
